import { Avatar, Popover } from '@material-ui/core';
import { upperCase } from 'lodash';
import * as React from 'react';

import { EmailAddress } from 'shared/types/email-compose';
import { CommunicationHeaderDetails } from './communication-header-details';

interface CommunicationHeadersProps {
    to: EmailAddress[];
    bcc: EmailAddress[];
    cc: EmailAddress[];
    from: EmailAddress;
    jobIds: string[];
    account: EmailAddress;
    subject: string;
    date: number;
}

const avatarSize = 30;

export const CommunicationHeaders: React.FC<CommunicationHeadersProps> = (props) => {
    const { from, to, cc, bcc } = props;
    const [headersAnchorRef, setHeadersAnchorRef] = React.useState<HTMLElement | null>(null);

    const getAddressee = (e: EmailAddress) => {
        return e.name ? e.name : e.address;
    };

    const initials = getAddressee(from)
        .split(' ')
        .map((s) => upperCase(s.charAt(0)));
    // tslint:disable-next-line:no-magic-numbers
    const avatarText = initials.length > 2 ? `${initials[0]}${initials[initials.length - 1]}` : initials;

    const handleOpenHeaders = (event: React.MouseEvent) => {
        setHeadersAnchorRef(event.currentTarget as HTMLElement);
    };

    const handleHideHeaders = () => {
        setHeadersAnchorRef(null);
    };

    const recipients = to.concat(cc).concat(bcc).map(getAddressee).join(', ');

    return (
        <>
            <div className="header-left" onClick={handleOpenHeaders}>
                <Avatar style={{ width: avatarSize, height: avatarSize, fontSize: avatarSize / 2 }}>
                    {avatarText}
                </Avatar>
                <div className="sender">{from.name}</div>
                <div className="recipients">to {recipients}</div>
            </div>
            <Popover
                open={!!headersAnchorRef}
                onClose={handleHideHeaders}
                anchorEl={headersAnchorRef}
                anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <CommunicationHeaderDetails
                    jobIds={props.jobIds}
                    account={props.account}
                    from={props.from}
                    to={props.to}
                    cc={props.cc}
                    bcc={props.bcc}
                    subject={props.subject}
                    date={props.date}
                />
            </Popover>
        </>
    );
};
